(() => {
  const initializedAttr = 'minipixSocialVideosInitialized';
  const videoSelector = '[data-minipix-social-video]';

  const hydrateVideo = (video) => {
    if (!video || video.dataset.minipixSocialHydrated === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    video.dataset.minipixSocialHydrated = 'true';
    video.load();
  };

  const playVideo = (video) => {
    if (!video) return;

    hydrateVideo(video);
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.play().catch(() => {});
  };

  const pauseVideo = (video) => {
    if (!video) return;

    video.pause();
  };

  const initSection = (section) => {
    if (section.dataset[initializedAttr] === 'true') return;

    const videos = Array.from(section.querySelectorAll(videoSelector));
    if (!videos.length) return;

    section.dataset[initializedAttr] = 'true';

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            playVideo(video);
          } else if (entry.intersectionRatio === 0) {
            pauseVideo(video);
          }
        });
      },
      { rootMargin: '360px 0px', threshold: [0, 0.2] }
    );

    videos.forEach((video) => observer.observe(video));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        videos.forEach(pauseVideo);
        return;
      }

      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom >= -360 && rect.top <= viewportHeight + 360) {
          playVideo(video);
        }
      });
    });
  };

  const initAllSections = () => {
    document.querySelectorAll('[data-minipix-social-videos]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
